/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { NonWidgetPage } from './non-widget-page-base';
import { iamLogin } from '../main';
import { iamLocalization } from '../localization';
import { iam } from '../iam';

export class IsAlreadySignedInPage extends NonWidgetPage {
  public override localize(): void {
    super.localize();
    iamLocalization.addLocalization(() => {
      iamLogin.localizeElement('pageTitle', 'signInTitle');
      iamLogin.localizeElement('main-header', 'existingSession');
      iamLogin.localizeElement('explanation', { stringKey: 'sessionAlreadyExists', stringParameters: { email: iamLogin.getEmailFromToken() } });
      iamLogin.localizeElement('logoutBtn', 'logOut');
      iamLogin.localizeElement('enterBtn', 'enterSession');
    });
  }

  public override initialize(): void {
    iamLogin.addLangOptions();
    if (iam.settings.debug) console.log('Show Already Signed In Widget');

    iamLogin.handleErrors();
    iamLogin.showWidget();

    document.getElementById('logoutBtn').addEventListener('click', e => {
      iamLogin.showTransitioningWidgetPage();
      this.elements.getContainer().querySelectorAll('button').forEach(button => {
        button.disabled = true;
      });
      iam.Token.logout();
    });
    document.getElementById('enterBtn').addEventListener('click', e => {
      iamLogin.showTransitioningWidgetPage();
      this.elements.getContainer().querySelectorAll('button').forEach(button => {
        button.disabled = true;
      });
      const redirectUri = window.sessionStorage.getItem('redirect_uri') || iam.settings.customPostLoginRedirect || iam.settings.appURL;
      window.sessionStorage.removeItem('redirect_uri');
      iam.Token.setLocation(redirectUri);
    });

    document.getElementById('loading-content').style.display = 'none';
    document.getElementById('right-pane-contents').style.display = '';
    this.showCommonFields(['explanation']);
    this.initializeCommon();
    this.initializePseudoWidgetCommon();

    // watch for "other" session to end - if it does, the "already logged in" functionality no longer makes sense
    setInterval(() => {
      if (!iamLogin.sessionIsActive()) {
        iam.Token.setLocation(iam.settings.discovery + '#loggedOut');
      }
    }, 250);
  }
}
